import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Tooltip } from "antd";
import Heading from "./Heading";
import InfoBlock from "./InfoBlock";
import { BoxDetailWrapperPrint, AdditionalCommentWrapper } from "../style";
import { UnderlyingContent } from "../../../style";
import { Block } from "../../../../GrantAgreement/styles";
import PurposeSummary from "../../../../../Components/PurposeSummary/PurposeSummary";
import { addressFormat } from "../../../utils";
import getRecognitionRender from "./ViewRecognition";

export const getPurposeComments = (purpose) =>
purpose.additionalComments ||
purpose.projectName ||
purpose.eventName ||
purpose.missionaryName ||
purpose.missionaryLocation ? (
  <>
    <Tooltip
      className="grantsFlow"
      placement="bottomLeft"
      trigger={window.innerWidth < 992 ? "click" : "hover"}
      title={() => <PurposeSummary {...purpose} />}
    >
      <UnderlyingContent>{purpose.purposeName}</UnderlyingContent>
    </Tooltip>
    {purpose.missionaryName ? (
      <div>Missionary Name - {purpose.missionaryName}.</div>
    ) : (
      ""
    )}
    {purpose.missionaryLocation ? (
      <div>Missionary Location - {purpose.missionaryLocation}.</div>
    ) : (
      ""
    )}
    {purpose.projectName ? (
      <div>Project Name - {purpose.projectName}.</div>
    ) : (
      ""
    )}
    {purpose.eventName ? <div>Event Name - {purpose.eventName}.</div> : ""}
    {purpose.additionalComments ? (
      <AdditionalCommentWrapper>
        {purpose.additionalComments}
      </AdditionalCommentWrapper>
    ) : (
      <div>No additional comments.</div>
    )}
  </>
) : (
  <>
    <Tooltip
      className="grantsFlow"
      placement="bottomLeft"
      trigger={window.innerWidth < 992 ? "click" : "hover"}
      title={() => <PurposeSummary {...purpose} />}
    >
      <UnderlyingContent>{purpose.purposeName}</UnderlyingContent>
    </Tooltip>
    {purpose.additionalComments ? (
      <AdditionalCommentWrapper>
        {purpose.additionalComments}
      </AdditionalCommentWrapper>
    ) : (
      <div>No additional comments.</div>
    )}
  </>
);

export const getAdditionalAttrRender = (purposeRecognition) => {
  const twoSections =
    purposeRecognition.notifyName &&
    (purposeRecognition.inMemoryOfName || purposeRecognition.inHonorOfName);
  return (
    <>
      {purposeRecognition.notifyName && (
        <Col span={twoSections ? 12 : 24}>
          <InfoBlock
            title="Please Notify"
            breakAll
            value={purposeRecognition.notifyName}
            confirmationPage={true}
          />
        </Col>
      )}
      {(purposeRecognition.inMemoryOfName ||
        purposeRecognition.inHonorOfName) && (
        <Col span={twoSections ? 11 : 24} offset={twoSections && 1}>
          <InfoBlock
            title="Additional Attribution"
            breakAll
            value={purposeRecognition.inMemoryOfName}
            value2={purposeRecognition.inHonorOfName}
            confirmationPage={true}
          />
        </Col>
      )}
    </>
  );
};

/**
 * Components layout is complicated because of the design requirements
 */
export default function Step1SummaryPrint({
  charityInfo = {},
  purposeRecognition = {},
  codeValueMappingData = {},
}) {
  return (
    <Row>
      <Col xs={0} md={0} lg={24}>
        <Row>
          <Col span={8}>
            <Heading
              title={charityInfo.title}
              edit={charityInfo.edit}
              handleEdit={charityInfo.handleEdit}
            />
          </Col>
          <Col span={14} offset={2}>
            <Heading
              title={purposeRecognition.title}
              edit={purposeRecognition.edit}
              handleEdit={purposeRecognition.handleEdit}
            />
          </Col>
        </Row>
        <Row type="flex">
          <BoxDetailWrapperPrint border span={8}>
            <InfoBlock
              border
              title="Full charity name"
              value={charityInfo.charityName}
            />
          </BoxDetailWrapperPrint>
          <BoxDetailWrapperPrint border span={14} offset={2}>
            <InfoBlock
              border
              title="Purpose"
              value={getPurposeComments(purposeRecognition)}
            />
          </BoxDetailWrapperPrint>
        </Row>
        <Row type="flex">
          <BoxDetailWrapperPrint border span={8}>
            <InfoBlock
              border
              title="Address"
              value={addressFormat(charityInfo.charityAddress)}
            />
          </BoxDetailWrapperPrint>
          <BoxDetailWrapperPrint border span={14} offset={2}>
            <InfoBlock
              border
              title="Grant Recognition"
              value={getRecognitionRender(
                purposeRecognition.grantRecognition,
                purposeRecognition.advisors,
                purposeRecognition.thirdParty,
                purposeRecognition.includeAdvisorInfo
              )}
            />
          </BoxDetailWrapperPrint>
        </Row>
        <Row type="flex">
          <BoxDetailWrapperPrint span={8}>
            <InfoBlock title="EIN" value={charityInfo.charityEin} />
          </BoxDetailWrapperPrint>
          <BoxDetailWrapperPrint span={14} offset={2}>
            {getAdditionalAttrRender(purposeRecognition)}
          </BoxDetailWrapperPrint>
        </Row>
      </Col>
      <Col md={24} xs={24} lg={0}>
        <Heading
          title={charityInfo.title}
          edit={charityInfo.edit}
          handleEdit={charityInfo.handleEdit}
        />
        <BoxDetailWrapperPrint border>
          <InfoBlock
            border
            title="Full Charity Name"
            value={charityInfo.charityName}
          />
        </BoxDetailWrapperPrint>
        <BoxDetailWrapperPrint border>
          <InfoBlock
            border
            title="Address"
            value={addressFormat(charityInfo.charityAddress)}
          />
        </BoxDetailWrapperPrint>
        <BoxDetailWrapperPrint border>
          <InfoBlock border title="EIN" value={charityInfo.charityEin} />
        </BoxDetailWrapperPrint>
        <Block mt="10" />
        <Heading
          title={purposeRecognition.title}
          edit={purposeRecognition.edit}
          handleEdit={purposeRecognition.handleEdit}
        />
        <BoxDetailWrapperPrint border>
          <InfoBlock
            border
            title="Purpose"
            value={getPurposeComments(purposeRecognition)}
          />
        </BoxDetailWrapperPrint>
        <BoxDetailWrapperPrint
          border={
            purposeRecognition.notifyName ||
            purposeRecognition.inMemoryOfName ||
            purposeRecognition.inHonorOfName
          }
        >
          <InfoBlock
            border
            title="Grant Recognition"
            value={getRecognitionRender(
              purposeRecognition.grantRecognition,
              purposeRecognition.advisors,
              purposeRecognition.thirdParty,
              purposeRecognition.includeAdvisorInfo
            )}
          />
        </BoxDetailWrapperPrint>
        {(purposeRecognition.notifyName ||
          purposeRecognition.inMemoryOfName ||
          purposeRecognition.inHonorOfName) && (
          <BoxDetailWrapperPrint>
            {getAdditionalAttrRender(purposeRecognition)}
          </BoxDetailWrapperPrint>
        )}
      </Col>
    </Row>
  );
}

Step1SummaryPrint.propTypes = {
  charityInfo: PropTypes.shape({
    charityAddress: PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    charityEin: PropTypes.string,
    charityName: PropTypes.string,
    title: PropTypes.string,
  }),
  purposeRecognition: PropTypes.shape({
    accountName: PropTypes.string,
    additionalComments: PropTypes.string,
    advisors: PropTypes.array,
    eventName: PropTypes.string,
    grantRecognition: PropTypes.string,
    inHonorOfName: PropTypes.string,
    inMemoryOfName: PropTypes.string,
    includeAdvisorInfo: PropTypes.bool,
    missionaryLocation: PropTypes.string,
    missionaryName: PropTypes.string,
    notifyName: PropTypes.any,
    projectName: PropTypes.string,
    purposeName: PropTypes.string,
    thirdParty: PropTypes.string,
    title: PropTypes.string,
  }),
  codeValueMappingData: PropTypes.object,
};
